module.exports = __webpack_public_path__ + "img/sale-outlet.b895c48e.jpeg";